<template>
  <b-modal id="reset-password-real-person" hide-footer hide-header no-stacking>
    <template v-slot:default="{ hide }">
      <!-- Close Button Container -->
      <div class="close-button-container">
        <span class="close-button" @click="hide()">&times;</span>
      </div>
      <!-- End Close Button Container -->

      <!-- Modal Main Content -->
      <div class="modal-main-content">
        <!-- Logo -->
        <div class="logo">
          <img src="@/assets/images/logo.png" alt="roshd logo" />
        </div>
        <!-- End Logo -->

        <!-- Title -->
        <div class="heading mb-4">
          <h6>بازیابی رمز عبور</h6>
        </div>
        <!-- End Title -->

        <!-- Form -->
        <form @submit.prevent="resetPassword">
          <p class="font-size-12 mb-2">رمز عبور جدید را وارد کنید</p>
          <!-- Password -->
          <span class="font-size-10"
            >حداقل 8 کاراکتر لاتین شامل اعداد و حروف کوچک و بزرگ</span
          >
          <div
            class="form-group input-password-type position-relative"
            :class="{ 'form-group--error': $v.pass.$error }"
          >
            <i
              class="icon-eye"
              @mousedown="password = 'text'"
              @mouseup="password = 'password'"
              @mouseleave="password = 'password'"
            ></i>
            <input
              :type="password"
              name="password"
              class="form-control"
              v-model.trim="pass"
              @input="delayTouch($v.pass)"
              placeholder="رمز عبور (فقط حروف و کاراکتر لاتین)"
            />

            <div
              class="error"
              v-if="!$v.pass.required && $v.pass.persianWordCheck"
            >
              وارد نمودن رمز عبور الزامی است.
            </div>
            <div
              class="error"
              v-if="!$v.pass.minLength && $v.pass.persianWordCheck"
            >
              رمز عبور باید حداقل هشت کاراکتر باشد.
            </div>
            <div class="error" v-if="!$v.pass.persianWordCheck">
              کیبورد شما فارسی است!
            </div>
          </div>
          <!-- Password -->

          <!-- Confirm Pass -->
          <div
            class="form-group input-password-type position-relative"
            :class="{ 'form-group--error': $v.confirm.$error }"
          >
            <i
              class="icon-eye"
              @mousedown="passwordConf = 'text'"
              @mouseup="passwordConf = 'password'"
              @mouseleave="passwordConf = 'password'"
            ></i>
            <input
              :type="passwordConf"
              name="confirm"
              v-model.trim="confirm"
              @input="delayTouch($v.confirm)"
              class="form-control"
              placeholder="تکرار رمز عبور"
            />

            <div
              class="error"
              v-if="!$v.confirm.sameAsPassword && $v.confirm.persianWordCheck"
            >
              با رمز عبور مطابقت ندارد.
            </div>
            <div class="error" v-if="!$v.confirm.persianWordCheck">
              کیبورد شما فارسی است!
            </div>
          </div>
          <!-- Confirm Pass -->

          <!-- Submit Button -->
          <div class="text-center mt-4 mb-3">
            <button type="submit">ثبت</button>
          </div>
          <!-- Submit Button -->
        </form>
        <!-- End Form -->
      </div>
      <!-- End Modal Main Content -->
    </template>
  </b-modal>
</template>

<script>
import axios from "@/axios.js";
import { url, formErrors } from "@/mixins.js";
import { required, sameAs, minLength } from "vuelidate/lib/validators";

const touchMap = new WeakMap();

export default {
  name: "ResetPasswordRealPerson",
  mixins: [url, formErrors],
  data() {
    return {
      captchaImg: "",
      passwordConf: "password",
      password: "password",
      pass: "",
      confirm: "",
      captcha: "",
      errors: {
        success: "کلمه عبور با موفقیت تغییر کرد.",
        pass_en_num_err: "فرمت پسورد اشتباه است.",
        confirm_err: "پسورد و تکرار آن مطابقت ندارند.",
        time_is_end: "لطفا چند لحظه دیگر مجددا تلاش کنید.",
      },
    };
  },
  computed: {
    urlCap() {
      return `${this.basicUrl}assets/images/captcha/`;
    },
  },
  validations: {
    pass: {
      required,
      minLength: minLength(8),
      persianWordCheck(val) {
        let pattern = /^[^ابپتثجچحخدذرزژسشصضطظعغفقکگلمنوهیآئ]*$/g;

        if (!pattern.test(val)) {
          this.pass = "";
          return false;
        } else {
          return true;
        }
      },
    },
    confirm: {
      sameAsPassword: sameAs("pass"),
      persianWordCheck(val) {
        let pattern = /^[^ابپتثجچحخدذرزژسشصضطظعغفقکگلمنوهیآئ]*$/g;

        if (!pattern.test(val)) {
          this.confirm = "";
          return false;
        } else {
          return true;
        }
      },
    },
  },
  methods: {
    async resetPassword(submitEvent) {
      this.busy = true;
      this.$v.$touch();

      if (this.$v.$invalid) {
        setTimeout(() => {
          this.busy = false;
        }, 400);
        return;
      }

      let data = new FormData();

      data.append("password", submitEvent.target.elements.password.value);
      data.append("confirm", submitEvent.target.elements.confirm.value);
      data.append("action", "update_forgot_password");

      // reset password
      await axios
        .post("user/auth/forget-pwd/update_password.php", data)
        .then((data) => {
            
          switch (data.data.msg) {
            case 11:
              this.$snotify.warning(this.errors[data.data.msg]);
              setTimeout(() => {
                this.$refs.captchaInp.focus();
              }, 400);
              break;

            case "success":
              this.$snotify.success(this.errors[data.data.msg]);
              this.$root.$emit("bv::hide::modal", "reset-password-real-person");

              this.pass = "";
              this.confirm = "";
              break;

            case "empty_err":
              this.$snotify.warning(this.errors[data.data.msg]);
              break;

            case "pass_en_num_err":
              this.$snotify.warning(this.errors[data.data.msg]);
              break;

            case "confirm_err":
              this.$snotify.warning(this.errors[data.data.msg]);
              break;

            case "failure":
              this.$snotify.warning(this.errors[data.data.msg]);
              break;

            case "unable_to_set":
              this.$snotify.warning(this.errors[data.data.msg]);
              break;

            case "time_is_end":
              this.$snotify.warning(this.errors[data.data.msg]);
              break;

            default:
              this.$snotify.error("خطا در برقراری ارتباط با سرور");
          }
        })
        .catch((err) => console.error("Err lang :", err));

      this.busy = false;
    },

    delayTouch($v) {
      $v.$reset();
      if (touchMap.has($v)) {
        clearTimeout(touchMap.get($v));
      }
      touchMap.set($v, setTimeout($v.$touch, 1500));
    },
  },
};
</script>